import { Button, Col, Form, Row, Select } from "antd";
import { collection, getDocs, query, where } from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";

import { auth, db } from "../../../../../firebase";
import { v4 as uuidv4 } from "uuid";

function PropertyGroups({ propertyGroups, setPropertyGroups }) {
  const [propGroups, setPropGroups] = useState([]);
  const randomId = uuidv4();

  const addPropertyGroup = () => {
    const newPropertyGroup = {
      id: randomId,
      propertyGroupId: "",
    };
    setPropertyGroups([...propertyGroups, newPropertyGroup]);
  };

  const removePropertyGroup = (id) => {
    const updatedPropertyGroups = propertyGroups.filter(
      (propertyGroup) => propertyGroup.id !== id
    );
    setPropertyGroups(updatedPropertyGroups);
  };

  const handleChange = (value, id) => {
    const updatedPropertyGroups = propertyGroups.map((propertyGroup) => {
      if (propertyGroup.id === id) {
        return { ...propertyGroup, propertyGroupId: value };
      }
      return propertyGroup;
    });
    setPropertyGroups(updatedPropertyGroups);
  };
  const [user, loading] = useAuthState(auth);
  const [companyName, setcompanyName] = useState("");
  const [isCompanyNameFetched, setIsCompanyNameFetched] = useState(false);
  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user.uid));
      getDocs(userData)
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const res = doc.data();
            setcompanyName(res.companyName);
          });
          setIsCompanyNameFetched(true);
        })
        .catch((error) => {
          console.log("Error getting users: ", error);
        });
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);

  useEffect(() => {
    if (!isCompanyNameFetched) return;
    const fetchPropertyGroups = async () => {
      try {
        const propertyGroupRef = collection(
          db,
          "companies",
          companyName,
          "propertyGroups"
        );
        const snapshot = await getDocs(propertyGroupRef);
        const fetchedData = snapshot.docs.map((doc) => ({
          id: doc.id,
          value: doc.id,
          label: doc.data().propertyGroupName,
          ...doc.data(),
        }));
        setPropGroups(fetchedData);
      } catch (err) {
        console.error(err);
        alert(err.message);
      }
    };
    fetchPropertyGroups();
    console.log("==============");
  }, [companyName, isCompanyNameFetched]);

  console.log("Property Groups", propGroups);

  return (
    <>
      {propertyGroups.map((propertyGroup) => (
        <Row gutter={[8, 0]} key={propertyGroup.id}>
          <Col span={21}>
            <Form.Item
              key={propertyGroup.id}
              name={`propertyGroup${propertyGroup.id}`}
              style={{ width: "100%" }}
              rules={[
                {
                  required: propertyGroups.length === 1 ? true : false,
                  message: "At least one property group should be selected",
                },
              ]}
            >
              <Select
                value={propertyGroup.propertyGroupId}
                onChange={(value) => handleChange(value, propertyGroup.id)}
                options={propGroups}
                showSearch
                placeholder="Choose Property Group"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          <Col span={2}>
            {propertyGroups.length > 1 && (
              <Button
                className="roundSmallButton"
                onClick={() => {
                  removePropertyGroup(propertyGroup.id);
                }}
                type="primary"
                shape="circle"
                icon={<i className="fa-sharp fa-solid fa-xmark"></i>}
                size={"small"}
              />
            )}
          </Col>
        </Row>
      ))}
      <Button
        className="addPropertyGroupButton"
        type="primary"
        onClick={() => addPropertyGroup()}
        style={{ width: "100%" }}
        icon={<i className="fa-solid fa-circle-plus"></i>}
      >
        Add Another Property Group
      </Button>
    </>
  );
}

export default PropertyGroups;
